import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { getEntityByToken } from "../get_entity";

const COMPASS_PRODUCT_TOKENS = [
  "p_z2e7wjxu6t",
  "p_qsmqm9z8e9",
  "nopalera-2",
  "nopalera-3",
  "nopalera-4",
  "nopalera-5",
  "ramen-1",
  "ramen-2",
  "ramen-3",
  "ramen-4",
  "plant-dyed-1",
  "plant-dyed-2",
  "plant-dyed-3",
  "nyc-snack-1",
  "nyc-snack-2",
  "nyc-bev-1",
  "nyc-bev-2",
  "nyc-soap-1",
  "nyc-soap-2",
  "potluck-ssamjang-1",
  "potluck-gochujang-1",
  "potluck-doenjang-1",
  "potluck-kimchi-base-1",
];

export const compassProducts: FaireProductEntity[] = COMPASS_PRODUCT_TOKENS.map(
  (token) => getEntityByToken(token, "product")
).filter(
  (product: FaireProductEntity | undefined): product is FaireProductEntity =>
    product !== undefined
);

export const filterProducts = (
  products: FaireProductEntity[],
  filters: {
    categories?: string[];
    tags?: string[];
    maxWeight?: number;
    maxPrice?: number;
    inStock?: boolean;
  }
): FaireProductEntity[] => {
  return products.filter((product) => {
    const productCategory = product.categoryTokens?.[0];
    if (
      filters.categories &&
      (!productCategory || !filters.categories.includes(productCategory))
    ) {
      return false;
    }
    if (
      filters.tags &&
      !filters.tags.some((tag) => (product.tags ?? []).includes(tag))
    ) {
      return false;
    }
    if (filters.maxWeight && (product.weight ?? 0) > filters.maxWeight) {
      return false;
    }
    if (filters.maxPrice && product.priceDollars > filters.maxPrice) {
      return false;
    }
    if (filters.inStock !== undefined && product.inStock !== filters.inStock) {
      return false;
    }
    return true;
  });
};

export const getProductsByTrend = (trendId: string): FaireProductEntity[] => {
  const trendTagMap: Record<string, string[]> = {
    matcha: ["matcha"],
    "plant-dyed": ["plant-dyed", "natural-dye", "sustainable-textiles"],
    ramen: ["ramen", "instant-ramen", "japanese-ramen"],
  };

  const tags = trendTagMap[trendId] || [];
  if (tags.length === 0) {
    return [];
  }

  return compassProducts.filter((product) =>
    tags.some((tag) => (product.tags ?? []).includes(tag))
  );
};
